import { render, staticRenderFns } from "./FormNotice.vue?vue&type=template&id=b48ddfba&"
import script from "./FormNotice.vue?vue&type=script&lang=js&"
export * from "./FormNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/toshiya.murasaki/Docker/Laravel/TRIPLE-CROWN/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b48ddfba')) {
      api.createRecord('b48ddfba', component.options)
    } else {
      api.reload('b48ddfba', component.options)
    }
    module.hot.accept("./FormNotice.vue?vue&type=template&id=b48ddfba&", function () {
      api.rerender('b48ddfba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/member/common/Atoms/FormNotice.vue"
export default component.exports